import { useSnackbar } from 'notistack';
import { useRef } from 'react';
import { useRecentCallback } from './utils';

export function useSnackbarInstance() {
  let id = useRef<number | string>(null);
  const snackbar = useSnackbar();

  const [close] = useRecentCallback(() => {
    if (id.current) {
      snackbar.closeSnackbar(id.current);
      id.current = null;
    }
  });

  const [enqueue]: readonly [typeof snackbar.enqueueSnackbar, any] = useRecentCallback(
    (...props) => {
      close();
      id.current = snackbar.enqueueSnackbar(...props);
      return id.current;
    }
  );

  return { enqueue, close };
}
